export default {
  integrations: {
    title: {
      apps: 'Apps',
      integrations: 'Integrations',
      settings: 'Settings'
    },
    description:
      'Twism is deeply integrated with e-commerce and payment systems. If you use one of<br> the options below, them please choose your platform and Twism will get you connected.',
    subtitle: {
      connected: 'Connected',
      available: 'Available',
      comingSoon: 'Coming Soon'
    },
    disconnect: {
      successMessage: 'Success! You’ve disconnected your {name} account'
    },
    formInvalid: {
      error: 'Please, check all information passed!'
    }
  }
};
